export const P_LIFETIME = 'P_LIFETIME'